import styled from 'common/styled-components';

export const Fields = styled.div`
    max-width: 1499px;
    display: grid;
    margin: 0 auto;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-column-gap: 14px;
    grid-row-gap: 14px;
`;

export const Actions = styled.div`
    display: grid;
    grid-auto-flow: column;
    justify-content: end;
`;

export const NarrativeContainer = styled.div`
`;

export const MatterOption = styled.div<{header?: boolean}>`
    overflow: hidden;
    white-space: nowrap;
    display: block;
    text-overflow: ellipsis;
    ${props => props.header ? 'font-weight: bold;' : ''}
`;

export const TextContainer = styled.div<{tracked: boolean}>`
    display: flex;
    flex-direction: column;
    line-height: 1.1;
    ${props => props.tracked ? `
        min-width: calc(100% - 20px);
    ` : `
        width: 100%;
    `}
`;
